// extracted by mini-css-extract-plugin
module.exports = {"messageIcon":"messageIcon___zfh5n","inquiryContainer":"inquiryContainer___WnaGp","rightContainer":"rightContainer___2wcHX","placeholder":"placeholder___5f1cR"};